import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { EStrategyStatus } from 'src/app/domain/enum/strategy-status';
import { User } from 'src/app/domain/user';
import { Permissions } from 'src/app/domain/user-profile/permissions';
import { environment } from 'src/environments/environment';

@Injectable()
export class CoreData {

    private IMPERSONATE_AS = `${environment.appCode}_IMPERSONATE_AS_` + environment.name;
    private ROLE_AND_PERMISSIONS = `${environment.appCode}_ROLE_AND_PERMISSIONS_` + environment.name;
    private USERKEY = `${environment.appName}_USRINF_${environment.name}`;
    private STRAT_STATUS_FILTERSKEY = `${environment.appName}_FILTERS_${environment.name}`;
    private WITH_OAUTH = `${environment.appName}_WITH_OAUTH_` + environment.name;
    private TOKEN = `${environment.appCode}_TOKEN_` + environment.name;
    private SCOPE = `${environment.appCode}_SCOPE`;

    set Token(token: string) {
        localStorage.setItem(this.TOKEN, token);
    }

    get Token() {
        return localStorage.getItem(this.TOKEN) as string;
    }

    getUserFromJWTToken() {
        const u = new User();
        const decodedToken = jwtDecode(this.Token) as any
        if (decodedToken) {
            u.Email = decodedToken.email;
            u.FirstName = decodedToken.given_name;
            u.LastName = decodedToken.display_name.split(' ')[1];
        }
        return u;
    }

    get User(): User | undefined {
        return this.WithOauth2 ? this.getUserFromJWTToken() : JSON.parse(atob(this.Token))
    }

    // get UserInformation() {
    //     if (localStorage.getItem(this.USERKEY)) {
    //         return JSON.parse(atob(localStorage.getItem(this.USERKEY)));
    //     }
    // }

    // set UserInformation(ui: User) {

    //     if (ui) {
    //         localStorage.setItem(this.USERKEY, btoa(JSON.stringify(ui)));
    //     } else {
    //         localStorage.removeItem(this.USERKEY);
    //     }
    // }
    get SelectedScopeCode() {
        return localStorage.getItem(this.SCOPE)!;
    }

    set SelectedScopeCode(scope: string) {
        localStorage.setItem(this.SCOPE, scope);
    }

    get ImpersonateAs() {
        return localStorage.getItem(this.IMPERSONATE_AS)!;
    }

    set ImpersonateAs(email: string | undefined) {
        if (email)
            localStorage.setItem(this.IMPERSONATE_AS, email);
        else
            localStorage.removeItem(this.IMPERSONATE_AS);
    }

    get StrategyStatusFilter() {
        if (localStorage.getItem(this.STRAT_STATUS_FILTERSKEY)) {
            return JSON.parse(atob(localStorage.getItem(this.STRAT_STATUS_FILTERSKEY)));
        }
    }

    set StrategyStatusFilter(filter: EStrategyStatus) {
        if (filter) {
            localStorage.setItem(this.STRAT_STATUS_FILTERSKEY, btoa(JSON.stringify(filter)));
        } else {
            localStorage.removeItem(this.STRAT_STATUS_FILTERSKEY);
        }
    }

    get RoleAndPermissions(): Permissions[] | undefined {
        if (this.ImpersonateAs)
            return undefined;
        if (localStorage.getItem(this.ROLE_AND_PERMISSIONS)) {
            return JSON.parse(atob(localStorage.getItem(this.ROLE_AND_PERMISSIONS)));
        }
        return undefined;
    }

    set RoleAndPermissions(ui: Permissions[] | undefined) {
        if (ui) {
            localStorage.setItem(this.ROLE_AND_PERMISSIONS, btoa(JSON.stringify(ui)));
        } else {
            localStorage.removeItem(this.ROLE_AND_PERMISSIONS);
        }
    }

    get WithOauth2() {
        return Boolean(JSON.parse(localStorage.getItem(this.WITH_OAUTH) as string));
    }

    set WithOauth2(withOauth2: boolean) {
        localStorage.setItem(this.WITH_OAUTH, `${withOauth2}`);
    }


    get IsMobile() {
        return window.innerWidth < 960;
    }

    public get IsLoggedIn() {
        return this.Token && this.Token !== '' || false;
    }

    // get User() {
    //     return this.UserInformation;
    // }

    logout() {
        // this.Token = undefined;
        localStorage.removeItem(this.TOKEN);
    }
}
